<template>
      <div class="panel">
        <div class="panel-heading">
            <div class="panel-label">
                <h3 slot="header">Shops</h3>
            </div>
            <div class="searchAll">
                <p>Search All</p>
                <vue-checkbox-toggle
                    ref="checkbox"
                    v-model="searchAll"
                    show-labels
                    label-checked="on"
                    label-unchecked="off"
                >
                </vue-checkbox-toggle>
            </div>
            <div class="panel-toolbar">
                <router-link :to="{ name: $TYPES.ROUTES.REGISTRATION+'shop' }" class="btn btn-sm btn-primary">
                    Create new shop <i class="icon icon-cph_iconset_plus"></i>
                </router-link>
            </div>
        </div>
        <div class="panel-body">
            <show-map :shops="getShopsIncludingFilters"></show-map>
            <key-account-picker :currentUser="a" @changeUser="changeUser"></key-account-picker>
            <div slot="body">
                <vue-table ref="table" :useSearch="true"
                            :dataTable="getShopsIncludingFilters"
                            :defaultSortOrder="[getShopsTableSortOrder]"
                            :tableFields="shopsTableFields"
                            :page="page"
                            :filters="getShopsTableFilters"
                            @currentPage="setShopsTablePage($event)"
                            @onSearch="onSearch"
                            >
                    <template slot="actions" slot-scope="props">
                        <div class="btn-group" role="group">
                            <router-link v-for="button in buttons"
                            :to="linkGen(button.path, props.data.id)" :key="button.name" :class="button.btnClass" class="btn btn-sm" type="button" tag="button">
                                <i class="fa" :class="button.icon"></i>{{button.name}}
                            </router-link>
                        </div>
                    </template>
                </vue-table>
            </div>
        </div>
      </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Multiselect from 'vue-multiselect';

import Table from '../../../components/Panel/Table/Table';
import KeyAccountPicker from '../../../components/Shared/KeyAccountPicker/KeyAccountPicker';
import ShopsTableFields from '../../../utilities/tablesProperties/ShopsTableFields';
import Map from '../../../components/Panel/Geo/MapComponent.vue';
import VueCheckboxToggle from '../../../components/Shared/Toggler';

export default {
    name: 'shops',
    components: {
        'vue-table': Table,
        'showMap': Map,
        'key-account-picker': KeyAccountPicker,
        Multiselect,
        VueCheckboxToggle
    },
    props: {
        hideAddition: {
            type: Boolean,
            default: false
        },
        userTableView: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        getShops (newVal, oldVal) {
            this.SetShopsIncludingFilters(newVal);
        },
        searchAll (newVal, oldVal) {
            this.searchAll = newVal;
            this.setEitherDisabledShops(this.searchAll);
            this.GetAllShops(this.currentKeyAccount ? this.currentKeyAccount.id : undefined);
        }
    },
    created () {
        this.searchAll = this.getEitherDisabledShops;
        this.SetShopsIncludingFilters(this.getShops);
    },
    data () {
        return {
            a: undefined,
            shopsTableFields: ShopsTableFields,
            buttons: {
                'show':{
                    name: 'show',
                    path: '/{{id}}',
                    icon: 'show',
                    btnClass: 'btn-success'
                },
                'edit': {
                    name: 'edit',
                    path: '/{{id}}/edit',
                    icon: 'show',
                    btnClass: 'btn-info'
                },
                'products': {
                    name: 'products',
                    path: '/{{id}}/products',
                    icon: 'edit fa-pictures',
                    btnClass: 'btn-warning'
                },
                /*'assignUser': {
                        name: 'users',
                        path: '/{{id}}/assignUsers',
                        icon: 'edit'
                    },*/
                'remove': {
                    name: 'remove',
                    path: '/{{id}}/remove',
                    icon: 'remove',
                    btnClass: 'btn-danger'
                }
            },
            currentKeyAccount: null,
            searchAll: false
        };
    },
    computed: {
        ...mapGetters({
            getShops: 'getShops',
            getShopsTableFilters: 'getShopsTableFilters',
            getShopsTableSortOrder: 'getShopsTableSortOrder',
            getShopsIncludingFilters: 'getShopsIncludingFilters',
            page: 'getShopsTablePage',
            getUserChilds: 'getUserChilds',
            getUser: 'getUser',
            getEitherDisabledShops: 'getEitherDisabledShops'
        })
    },
    methods: {
        ...mapActions([
            'AddShopsTableFilters',
            'SetShopsIncludingFilters',
            'SetShopsTablePage',
            'GetAllShops'
        ]),
        ...mapMutations([
            'setActiveKeyAccount',
            'setEitherDisabledShops'
        ]),
        async changeUser (key_account) {
            this.a = key_account;
            await this.GetAllShops(key_account ? key_account.id : undefined);
        },
        setShopsTablePage (event) {
            switch(event) {
                case 'prev':
                    this.SetShopsTablePage(this.page ? this.page -1 : this.page);
                    break;
                case 'next':
                    this.SetShopsTablePage(this.page + 1);
                    break;
                default:
                    this.SetShopsTablePage(event);
            }
        },
        linkGen (path, id){
            return `/shops${path.replace('{{id}}', id)}`;
        },
        onSearch (data) {
            this.AddShopsTableFilters(data);
            this.SetShopsIncludingFilters(this.getShops);
        }
    },
    mounted (){
        this.AddShopsTableFilters({
            name: {
                value: '',
                field: 'name',
                placeholder: 'Search Name'
            },
            country: {
                value: '',
                field: 'address.country',
                placeholder: 'Search Country'
            },
            city: {
                value: '',
                field: 'address.city',
                placeholder: 'Search City'
            },
            externalID: {
                value: '',
                field: 'externalID',
                placeholder: 'External ID'
            }
        });
    }
};
</script>

<style lang="scss" scoped>
    .container {
        margin-top: 50px;
    }
    div.searchAll {
        display: flex;
        align-items: center;
        p {
            margin: 0;
        }
    }
</style>
